import React from 'react';
import { Button } from '@components/primitives/Button';
import { MiniTile } from '@components/ui/cards/FeatureCard';
import { Box } from '@mui/material';

interface AdminToolTileProps {
  imageSrc: string;
  imageAlt: string;
  buttonText: string;
  onClick?: () => void;
}

/**
 * AdminToolTile Component
 * 
 * A reusable tile component for administrative tools in the dashboard.
 * Encapsulates the MiniTile with consistent styling and image handling.
 */
export const AdminToolTile: React.FC<AdminToolTileProps> = ({
  imageSrc,
  imageAlt,
  buttonText,
  onClick = () => {},
}) => (
  <MiniTile
    sx={{
      overflow: 'hidden',
      height: '100%',
      minHeight: 280,
      maxWidth: { xs: '100%', lg: 230 },
      maxHeight: { xs: 300, sm: 'auto' },
    }}
    onClick={onClick}
    action={
      <Button variant="outlined" sx={{ whiteSpace: 'nowrap' }}>
        {buttonText}
      </Button>
    }
  >
    <Box
      component="img"
      src={imageSrc}
      alt={imageAlt}
      sx={{
        width: '100%',
        height: '100%',
        objectFit: 'contain',
        objectPosition: 'top',
      }}
    />
  </MiniTile>
);

export default AdminToolTile;